import { useState, useEffect, useRef } from "react"
//Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import $ from 'jquery'; 
import Warning from "../../../components/Warning";
import AlertMessage from "../../../components/AlertMessage";
import BasicCard from "../../../components/basics/cards/BasicCard"
import { Container, Row, Col, Button } from 'react-bootstrap';
import { GlobalScenarioAPIService } from "../../../services/apis/GlobalScenarioAPIService"
import '../../../css/administration.css'
import { ErrorService } from "../../../services/ErrorService";
import { ScenarioAPIService } from "../../../services/apis/ScenarioAPIService";
import { CommonAPIService } from "../../../services/apis/CommonAPIService";

function CreateEditGlobalScenario() {

    const tableRef = useRef();
    const { tableColumns, tableColumnIds } = { tableColumns: ['Name', 'Scenario type', 'Percentage type', 'Tagetik currency bucket'], tableColumnIds: ['scenarioName', 'scenarioType', 'percentageType', 'currencyBucket']}
    
    const initialState = {
        scenario: {
            scenarioCode: '',
            scenarioName: '',
            scenarioTypeId: 1,
            mappingTypeId: 1,
            percentageTypeId: 1,
            memo: '',
            sortIndex: 0,
            currencyBucketId: 1,
            lastUpdateDate: '',
            isDeleted: false,
        },
        scenarios: [],

    }

    const [showAddEdit, setShowAddEdit] = useState(false);
    const [state, setState] = useState(initialState);
    const [cancelWarning, setCancelWarning] = useState(false);
    const [alertObject, setAlertObject] = useState({ variant: '', alertMessage: '' });
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');
    const [currencies, setCurrencies] = useState([]);
    const [mappingTypes, setMappingTypes] = useState([]);

    const handleRowClick = (code) => {
        ScenarioAPIService.getScenarioByScenarioCode(code).then(scenarioData => {
            var scenario = {
                scenarioId: scenarioData.scenarioId,
                scenarioCode: scenarioData.scenarioCode,
                scenarioName: scenarioData.scenarioName,
                scenarioTypeId: scenarioData.scenarioTypeId,
                percentageTypeId: scenarioData.percentageTypeId,
                memo: scenarioData.memo,
                currencyBucketId: scenarioData.currencyBucketId,
                defaultCurrencyId: scenarioData.defaultCurrencyId,
                mappingTypeId: scenarioData.mappingTypeId,
                sortIndex: scenarioData.sortIndex,
                isDeleted: scenarioData.isDeleted,
                nodes: scenarioData.nodes,
                lastUpdateDate: scenarioData.lastUpdateDate
            };
            setState(values => ({ ...values, scenario: scenario }));
            setShowAddEdit(true);
        });
    }
   
    useEffect(() => {

        CommonAPIService.getMappingTypes()
            .then(data => setMappingTypes(data))

        ScenarioAPIService.getCurrencyBuckets()
            .then(data => setCurrencies(data))

        GlobalScenarioAPIService.getAll()
            .then(data => {
                setIsLoading(false);

                if (data.error)
                    setError(ErrorService.getErrorMessage(data.error.status));
                else {
                    setState(values => ({ ...values, scenarios: data }))
                    setError(false)
                }
            });


        if (tableColumns.length > 0) {
            const table = $(tableRef.current).DataTable({
                select: true,
                lengthChange: false,
                paging: true,
                searching: true,
                columns: tableColumns.map(col => { return { title: col } }),
                destroy: true
            });
            return () => table.destroy();
        }

    }, []);

    const renderRow = (row) => {
        if (typeof row === 'object')
            return "";
        else if (typeof row === 'string')
            return row.replace("\u0000", "")
        else
            return row;
    }

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        const scenario = state.scenario;
        scenario[name] = value;
        setState(values => ({ ...values, scenario: scenario }))
    }

    const handleCheck = (e) => {
        const name = e.target.name;
        const value = e.target.checked;
        const scenario = state.scenario;
        scenario[name] = value;
        setState(values => ({ ...values, scenario: scenario }))
    }

    const handleAddItem = () => {
        var scenario = {
            scenarioId: '',
            scenarioCode: '',
            scenarioName: '',
            scenarioTypeId: 1,
            sortIndex: '',
            memo: '',
            percentageTypeId: 1,
            currencyBucketId: 1,
            mappingTypeId: 1,
            isDeleted: false,
            lastUpdateDate: '',
        };
        setState(values => ({ ...values, scenario: scenario }));
        setShowAddEdit(true);

        if (!showAddEdit) {
            setShowAddEdit(true)
        }
    }
    // EVENT HANDLERS
    const handleCancel = () => {
        setCancelWarning(true)
    }


    const handleConfirm = (value) => {
        setCancelWarning(value)
        setShowAddEdit(value)
    }

    const handleSave = (e) => {
        e.preventDefault()
        setAlertObject({ variant: '', alertMessage: '' });

        if (state.scenario.scenarioName === "" || state.scenario.scenarioName === undefined) {
            setAlertObject({ variant: 'danger', alertMessage: 'Scenario name should not be empty.' })
            return false;
        }

        if (state.scenario.mappingTypeId === "" || state.scenario.mappingTypeId === undefined) {
            setAlertObject({ variant: 'danger', alertMessage: 'Mapping type must be supplied.' })
            return false;
        }

        if (state.scenario.percentageTypeId === "" || state.scenario.percentageTypeId === undefined) {
            setAlertObject({ variant: 'danger', alertMessage: 'Percentage type must be supplied.' })
            return false;
        }

        if (state.scenario.currencyBucketId === "" || state.scenario.currencyBucketId === undefined) {
            setAlertObject({ variant: 'danger', alertMessage: 'Tagetik currency bucket must be supplied.' })
            return false;
        }

        var newItem = {
            scenarioCode: state.scenario.scenarioCode ?? "",
            scenarioName: state.scenario.scenarioName,
            scenarioTypeId: 1,  // GLOBAL scenario type ID
            mappingTypeId: state.scenario.mappingTypeId,
            percentageTypeId: state.scenario.percentageTypeId,
            memo: state.scenario.memo,
            sortIndex: state.scenario.sortIndex === "" ? 0 : state.scenario.sortIndex,
            currencyBucketId: state.scenario.currencyBucketId,
            lastUpdateDate: (new Date()).toISOString(),
            isDeleted: state.scenario.isDeleted,
        };

        if (state.scenario.scenarioId !== "" && state.scenario.scenarioId !== undefined) {
            //GlobalScenarioAPIService.updateNode(state.scenario['scenarioId'], newItem).then(
            //    data => {
            //        if (data.error) {
            //            setError(ErrorService.getErrorMessage(data.error.status))
            //        }
            //        const newItems = state.scenarios;
            //        newItems[state.scenario['scenarioId']] = data;
            //        console.log(newItems);
            //        setState(values => ({ ...values, scenarios: newItems }));
            //        setShowAddEdit(false);
            //    }
            //);

            ScenarioAPIService.update(newItem).then(
                data => {

                    //const scenarios = state.scenarios;
                    //const scenario = scenarios.find(
                    //    s => s.scenarioId === newItem.scenarioId
                    //);
                    //scenario.scenarioCode=state.scenario.scenarioCode;
                    //scenario.scenarioName = state.scenario.scenarioName;
                    //scenario.scenarioTypeId = 1;  // GLOBAL scenario type ID
                    //scenario.mappingTypeId = state.scenario.mappingTypeId;
                    //scenario.percentageTypeId = state.scenario.percentageTypeId;
                    //scenario.memo = state.scenario.memo;
                    //scenario.sortIndex = state.scenario.sortIndex;
                    //scenario.currencyBucketId= state.scenario.currencyBucketId;
                    //scenario.lastUpdateDate=(new Date()).toISOString();
                    //scenario.isDeleted = state.scenario.isDeleted;

                    //console.log(scenarios);

                    //setState(values => ({ ...values, scenarios: scenarios }));
                    //console.log(state);

                    GlobalScenarioAPIService.getAll()
                        .then(data => {
                            setIsLoading(false);

                            if (data.error)
                                setError(ErrorService.getErrorMessage(data.error.status));
                            else {
                                setState(values => ({ ...values, scenarios: data }))
                                setError(false)
                            }
                        });

                    //const newItems = state.scenarios;
                   // newItems[state.scenario.scenarioId] = newItem;
                   // setState(values => ({ ...values, scenarios: newItems }));
                    setAlertObject({ variant: 'success', alertMessage: 'Scenario updated' })
                }
            );   


        }
        else {
            GlobalScenarioAPIService.add(newItem).then(
                data => {
                    if (data.error) {
                        setError(ErrorService.getErrorMessage(data.error.status))
                    }
                    const newItems = state.scenarios;
                    newItems.push(data);
                    setState(values => ({ ...values, scenarios: newItems }));
                    setShowAddEdit(false);
                }
            );
        }
    }

    return (
        <Container fluid className='basic-listing-container'>
            <Row>
                <Col>
                    <BasicCard cardConfig={{ cardTitle: 'Scenarios', cardHeadingElement: 'h4' }}>
                        {isLoading ? <p>Loading data ...</p> : ""}
                        {error ? <p style={{ color: 'red' }}>{error}</p> : ""}
                        {
                            <div className='listing-table-wrapper'>
                                {state.scenarios?.length > 0 ?
                                    <table className='react-data-table' ref={tableRef}>
                                        <thead>
                                            <tr>
                                                {
                                                    tableColumns.map((column, index) => <th key={index}>{column}</th>)
                                                }
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {state.scenarios.map((tableRow, index) => {
                                                return (
                                                    <tr className={'react-data-table-effect'} key={index} onClick={() => handleRowClick(tableRow['scenarioCode'])}>
                                                        {tableColumnIds.map((tableCol, index) => {
                                                            if (tableCol === 'nodes') return <td key={1000 + index}>--SCENARIO_ARRAY--</td>
                                                            return (
                                                                <td key={1000 + index}>
                                                                    <div className='data-table-input-cell'>
                                                                        <p className='data-table-text'>{renderRow(tableRow[tableCol])}
                                                                        </p>
                                                                    </div>
                                                                </td>
                                                            )
                                                        })}

                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                    : ""}
                                <Button variant='primary' onClick={handleAddItem} className='listing-add-button'>+</Button>
                            </div>
                        }
                    </BasicCard>
                </Col>
                {showAddEdit && (
                    <Col>
                        <BasicCard cardConfig={{ cardTitle: 'Scenario details', cardHeadingElement: 'h4' }}>
                            {alertObject.alertMessage ? <AlertMessage alertObject={alertObject} setAlertObject={setAlertObject} /> : ""}
                            <ul className='add-edit-detail-list'>
                                {state.scenario.scenarioCode !== "" ?
                                    <li>
                                        <span className='form-row'>
                                            <label className='label'>Scenario code</label>
                                            <input type='text' name="scenarioCode" value={state.scenario.scenarioCode} disabled onChange={handleChange} className='form-input'></input>
                                        </span>
                                    </li> : ""
                                }
                                <li>
                                    <span className='form-row'>
                                        <label className='label'>Scenario name</label>
                                        <input type='text' name="scenarioName" value={state.scenario.scenarioName} onChange={handleChange} className='form-input'></input>
                                    </span>
                                </li>
                                <li>
                                    <span className='form-row'>
                                        <label className='label'>Scenario type</label>
                                        <label className='label'>Global</label>
                                    </span>
                                </li>
                                <li>
                                    <span className='form-row'>
                                        <label className='label'>Mapping type</label>
                                        <select name="mappingTypeId" value={state.scenario.mappingTypeId} onChange={handleChange} className='form-select' >
                                            {mappingTypes.map((mappingType) => {
                                                return (
                                                    <option key={mappingType.mappingTypeId} value={mappingType.mappingTypeId}>
                                                        {mappingType.mappingTypeName}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                    </span>
                                </li>
                                <li>
                                    <span className='form-row'>
                                        <label className='label'>Percentage type</label>
                                        <select name="percentageTypeId" value={state.scenario.percentageTypeId} onChange={handleChange} className='form-select' >
                                            <option value="1">FIXED</option>
                                            <option value="2">Flexible</option>
                                        </select>
                                    </span>
                                </li>
                                <li>
                                    <span className='form-row'>
                                        <label className='label-textarea'>Scenario memo</label>
                                        <textarea name="memo" value={state.scenario.memo} onChange={handleChange} className='form-text-area' rows='4' cols='50'></textarea>
                                    </span>
                                </li>
                                <li>
                                    <span className='form-row'>
                                        <label className='label'>Sort index</label>
                                        <input type='number' name="sortIndex" value={state.scenario.sortIndex} onChange={handleChange} className='form-input'></input>
                                    </span>
                                </li>
                                <li>
                                    <span className='form-row'>
                                        <label className='label'>Tagetik currency bucket</label>
                                        <select name="currencyBucketId" value={state.scenario.currencyBucketId} onChange={handleChange} className='form-select' >
                                            {currencies.map((currency) => {
                                                return (
                                                    <option key={currency.currencyBucketId} value={currency.currencyBucketId}>
                                                        {currency.name}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                    </span>
                                </li>
                                <li>
                                    <span className='form-row'>
                                        <label>Deleted</label>
                                        <input type='checkbox' name='isDeleted' onChange={handleCheck} checked={state.scenario.isDeleted}></input>
                                    </span>
                                </li>
                                {state.scenario.nodeId !== "" ?
                                    <li>
                                        <span className='form-row'>
                                            <label className='label'>Last updated</label>
                                            <p className='form-input-right'>{state.scenario.lastUpdateDate}</p>
                                        </span>
                                    </li> : ""
                                }
                            </ul>
                            <span className='cancel-save'>
                                <a href='#' onClick={handleCancel}>Cancel</a>
                                <Button variant='primary' onClick={handleSave}>Save</Button>
                            </span>
                            <Warning warningText='Are you sure you want to cancel?' handleConfirm={setCancelWarning} handleCancel={setShowAddEdit} show={cancelWarning} />
                        </BasicCard>
                    </Col>
                )}
            </Row>
        </Container>
    )
}

export default CreateEditGlobalScenario